import moment from 'moment';
import { useState, useContext } from 'react';
import _isNil from 'lodash/isNil';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { AppContext, ERROR_SEVERITY } from 'commons-ui';
import { SelectedRefundType } from 'pages/dashboard/downtimeRefund/listRefundRequest/types';
import { DOWNTIME_REFUND_MINIMUM_TIME_DIFF_IN_MINUTES } from 'constant';
import useService from '../../../useService';
import { SEVEN_DAYS_IN_MS } from '../../constants';

const useRefundDetails = () => {
	const [showLoader, setShowLoader] = useState(false);
	const { showAlert } = useContext(AppContext);
	const history = useHistory();
	const { createRefundRequest } = useService();
	const { path } = useRouteMatch();

	const handleFormSubmit = async (selectedRefund: SelectedRefundType) => {
		setShowLoader(true);
		const { gameName, downtimeType, startTime, endTime } = selectedRefund;
		const maxDate = moment().subtract(DOWNTIME_REFUND_MINIMUM_TIME_DIFF_IN_MINUTES, 'minutes').valueOf();
		try {
			setShowLoader(false);
			if (_isNil(startTime) || _isNil(endTime)) {
				showAlert('start time and end time can not be blank', { type: ERROR_SEVERITY.ERROR });
			} else if (endTime < startTime) {
				showAlert('End time should not be greater than start time', { type: ERROR_SEVERITY.ERROR });
				setShowLoader(false);
			} else if (endTime - startTime > SEVEN_DAYS_IN_MS) {
				showAlert('range should not be greater than 7 days', { type: ERROR_SEVERITY.ERROR });
				setShowLoader(false);
			} else if (endTime > maxDate) {
				showAlert('The end time must not be within the last 15 minutes.', { type: ERROR_SEVERITY.ERROR });
				setShowLoader(false);
			} else {
				const response = await createRefundRequest(gameName, downtimeType, startTime, endTime, showAlert);
				if (response) {
					history.push({
						pathname: `${path}/listRefundRequests`
					});
				}
			}
		} catch (error: any) {
			showAlert(error.error || 'Something went wrong', { type: ERROR_SEVERITY.ERROR });
			setShowLoader(false);
		}
	};

	const handleFormCancel = () => {
		history.goBack();
	};

	return { showLoader, setShowLoader, handleFormCancel, handleFormSubmit };
};
export default useRefundDetails;
